import React, { useEffect, useState } from 'react'
import { UiState } from '../../../types'

type Props = {
  marketoFormRef: React.RefObject<HTMLFormElement>
  state: UiState
}
const MARKETO_JS_NAME = '/js/forms2/js/forms2.min.js'
const MARKETO_FORM_ID_PREFIX = 'mktoForm_'

export const MarketoForm: React.FC<Props> = props => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = process.env.VITE_MARKETO_DOMAIN + MARKETO_JS_NAME
    script.onload = () => setIsScriptLoaded(true)
    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [])

  useEffect(() => {
    if (!isScriptLoaded) return
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(window as any).MktoForms2?.loadForm(
      process.env.VITE_MARKETO_DOMAIN,
      process.env.VITE_MARKETO_MUNCHKINID,
      process.env.VITE_MARKETO_FORMID
    )
  }, [isScriptLoaded])

  return (
    <form
      style={{ display: 'none' }}
      id={MARKETO_FORM_ID_PREFIX + process.env.VITE_MARKETO_FORMID}
      ref={props.marketoFormRef}
    />
  )
}
